import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { crearPais } from "../../../services/pais.service";
import { ContenedorPageTemplate } from "../../../components/templates/ContenedorPageTemplate";
import { FormHook } from "../../../components/molecules/FormHook";
import { FormDiv } from "../../../components/atoms/FormDiv";
import { SubmitButton } from "../../../components/atoms/SubmitButton";
import { FormInput } from "../../../components/molecules/FormInput";
import { showAlert, showErrorAlert } from "../../../components/molecules/ShowAlert";

export const CrearPaisPage = () => {
  const navigate = useNavigate();
  const DIR_ICON_MAT = "img/iconos/titulo de docente (con la pizarra).svg";
  const [estaCargando, setEstaCargando] = useState(false);
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const submit = async (data) => {
    setEstaCargando(true);
    try {
      await crearPais(data);
      showAlert({
        callback: () => navigate("/pais"),
      });
    } catch (err) {
      const errorMessage = err.response?.data?.message || "Error al crear el país";
      showErrorAlert({ text: errorMessage });
    } finally {
      setEstaCargando(false);
    }
  };

  return (
    <ContenedorPageTemplate dirIcono={DIR_ICON_MAT} titulo="Crear País">
      <FormHook
        handleSubmit={handleSubmit}
        submit={submit}
        className="w-[min(100%,700px)] mx-auto"
      >
        <FormDiv>
          <FormInput
            id="nombre"
            label="Nombre del País"
            type="text"
            placeholder="Nombre del país"
            register={register}
            validation={{
              required: { value: true, message: "Campo requerido" },
              maxLength: {
                value: 60,
                message: "Súpero la cantidad máxima de 60 caracteres",
              },
              minLength: { value: 1, message: "Mínimo 1 caracter" },
            }}
            error={errors.nombre}
          />
        </FormDiv>
        <SubmitButton estaCargando={estaCargando} text="Guardar" />
      </FormHook>
    </ContenedorPageTemplate>
  );
};